﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Web3Controller = void 0;
const AppControllerBase_1 = require("./AppControllerBase");
const AppSV_1 = require("../AppSV");
const PriceKeeperContract_1 = require("../contracts/PriceKeeperContract");
const gs_1 = require("@ivanlog/gs");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const SmartVaultManagerContract_1 = require("../contracts/SmartVaultManagerContract");
const LLVaultManagerContract_1 = require("../contracts/LLVaultManagerContract");
const SmartVaultContract_1 = require("../contracts/SmartVaultContract");
const ERC20Contract_1 = require("../contracts/ERC20Contract");
const BiMath_1 = require("../BiMath");
const DiffCalcContract_1 = require("../contracts/DiffCalcContract");
class Web3Controller extends AppControllerBase_1.AppControllerBase {
    constructor(app) {
        super(app);
        this._onChangeAccountToken = new gs_1.EventAsyncToken();
        this._onChangeAccount = new gs_1.EventAsyncGS(this._onChangeAccountToken);
    }
    get onChangeAccount() { return this._onChangeAccount; }
    get isConnected() { return this._web3 != undefined; }
    get web3() { return this._web3; }
    get account() {
        return this._account;
    }
    get addressTokenUSDL() { return this._addressTokenUSDL; }
    get usdlToken() { return this._usdlToken; }
    get priceKeeperPLS() { return this._priceKeeperPLS; }
    get smartVaultManager() { return this._smartVaultManager; }
    get llVaultManagerContract() { return this._llVaultManagerContract; }
    get diffCalc() { return this._diffCalc; }
    get smartVaults() { return this._smartVaults; }
    // 
    // get addressTokenLOAN(){ return this._addressTokenLOAN;}
    // get addressTokenUP(){ return this._addressTokenUP;}
    // get addressPriceKeeperPLS(){ return this._addressPriceKeeperPLS;}
    // get addressPriceKeeperUP(){ return this._addressPriceKeeperUP;}
    // get internalExchangerBnB(){ return this._internalExchangerBnB;}
    // get internalExchangerSP(){ return this._internalExchangerSP;}
    // 
    // get priceKeeperUP(){return this._priceKeeperUP;}
    // get upManager(){return this._upManager;}
    // get buyBurnPool(){return this._buyBurnPool;}
    // get stabilityPool(){return this._stabilityPool;}
    // get burnableUp(){return this._burnableUp;}
    // get shareX(){return this._shareX;}
    // get liquidControllers(){ return this._liquidControllers.slice();}
    start() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.initWeb3();
        });
    }
    getAccountAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._account)
                return this._account;
            const result = this.refreshAccountAsync();
            return result;
        });
    }
    refreshAccountAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const eth = globalThis.ethereum;
            //chain validation
            const currentChainId = yield eth.request({ method: 'eth_chainId' });
            if (currentChainId != 943) {
                new modalCom.DialogOk("Wrong blockchain selected. Change blockchain and refresh page.").show();
                return;
            }
            const accounts = yield eth.request({ method: 'eth_requestAccounts' });
            this._account = accounts[0];
            this._web3 = new globalThis.Web3(eth);
            this._usdlToken.updateWeb3(this._web3);
            this._priceKeeperPLS.updateWeb3(this._web3);
            this._smartVaultManager.updateWeb3(this._web3);
            this._llVaultManagerContract.updateWeb3(this._web3);
            this._diffCalc.updateWeb3(this._web3);
            yield this._onChangeAccountToken.invoke();
            return this._account;
        });
    }
    getBalanceEth() {
        return __awaiter(this, void 0, void 0, function* () {
            const account = this.account;
            if (!account)
                return;
            try {
                const balance = yield this._web3.eth.getBalance(account);
                return this._web3.utils.fromWei(balance, 'ether');
            }
            catch (error) { }
            return;
        });
    }
    addTokenToWalletAsync(address, symbol, decimal) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!globalThis.ethereum)
                return false;
            const eth = globalThis.ethereum;
            try {
                // 'wasAdded' is a boolean. Like any RPC method, an error can be thrown.
                const wasAdded = yield eth.request({
                    method: 'wallet_watchAsset',
                    params: {
                        type: 'ERC20',
                        options: {
                            address: address,
                            symbol: symbol,
                            decimals: decimal, // The number of decimals in the token.
                            //image: tokenImage, // A string URL of the token logo.
                        },
                    },
                });
                return wasAdded;
            }
            catch (error) {
                console.log(error);
                return false;
            }
        });
    }
    refreshSmartVaults() {
        return __awaiter(this, void 0, void 0, function* () {
            this._smartVaults = [];
            var vaultsInfo = yield this._smartVaultManager.getSmartVaultsForAddressAsync(0, this._account);
            for (const info of vaultsInfo) {
                const contact = new SmartVaultContract_1.SmartVaultContract(info.addrs, this._web3);
                contact.refreshInfo(info);
                this._smartVaults.push(contact);
            }
            this._smartVaults = this._smartVaults.sort((a, b) => parseFloat(a.getInfo().FCRIndex) - parseFloat(b.getInfo().FCRIndex));
        });
    }
    initWeb3() {
        return __awaiter(this, void 0, void 0, function* () {
            //if (!globalThis.ethereum) return;
            // if (win.web3 !== undefined) {
            //     const provider = new Web3.providers.HttpProvider(win.web3.currentProvider);
            //     const web3 = new Web3(provider);
            // }
            // if (win.ethereum !== undefined) {
            //     const provider = new Web3.providers.HttpProvider(win.ethereum);
            //     const web3 = new Web3(provider);
            //     this._web3 = web3;
            // }
            //     const eth=globalThis.ethereum;
            //     //chain validation
            //     const currentChainId = await eth.request({method: 'eth_chainId'});       
            //     if (currentChainId != 943) {
            //         new modalCom.DialogOk("Wrong blockchain selected. Change blockchain and refresh page.").show();
            //         return;
            //     }
            //    // const accounts = await eth.request({ method: 'eth_requestAccounts' });
            //   //  this._account = accounts[0];
            //     this._web3 = new globalThis.Web3(eth);
            try {
                const ethereum = window.ethereum;
                this._web3 = new globalThis.Web3(new globalThis.Web3.providers.HttpProvider(AppSV_1.AppSV.CHAIN_RPC));
                BiMath_1.BiMath.Init(this._web3);
                this._usdlToken = new ERC20Contract_1.ERC20Contract(AppSV_1.AppSV.ADDRESS_USDL_ERC20, this._web3);
                this._priceKeeperPLS = new PriceKeeperContract_1.PriceKeeperContract(AppSV_1.AppSV.ADDRESS_PriceKeeperPLS, this._web3);
                this._smartVaultManager = new SmartVaultManagerContract_1.SmartVaultManagerContract(AppSV_1.AppSV.ADDRESS_SmarVaultManager, this._web3);
                this._llVaultManagerContract = new LLVaultManagerContract_1.LLVaultManagerContract(AppSV_1.AppSV.ADDRESS_LLVaultManager, this._web3);
                this._diffCalc = new DiffCalcContract_1.DiffCalcContract(AppSV_1.AppSV.ADDRESS_DIFF_CALC, this._web3);
                if (ethereum) {
                    //Отлавливаем изменение аккаунта и обновляем аккаунт
                    ethereum.on('accountsChanged', (accounts) => __awaiter(this, void 0, void 0, function* () {
                        yield this.refreshAccountAsync();
                    }));
                    //Отлавливаем изменение чейна и обновляем аккаунт
                    ethereum.on('chainChanged', (accounts) => __awaiter(this, void 0, void 0, function* () {
                        yield this.refreshAccountAsync();
                    }));
                }
                yield this.refreshSmartVaults();
                // this._smartVaults=[];
                // var vaultsInfo = await this._smartVaultManager.getSmartVaultsAsync();
                // for(const info of vaultsInfo)
                // {
                //     const contact = new SmartVaultContract(info.addrs, this._web3);
                //     contact.refreshInfo(info);
                //     this._smartVaults.push(contact);
                // }
                // this._smartVaults=this._smartVaults.sort((a,b)=>parseFloat(a.getInfo().FCRIndex)-parseFloat(b.getInfo().FCRIndex));
                // console.log(vaultsInfo);
                // this._upManager = new UpManagerContract(AppSV.ADDRESS_upManager, this._web3);
                // this._addressPriceKeeperPLS = await this._upManager.getPriceKeeperPLS();
                // this._addressPriceKeeperUP = await this._upManager.getPriceKeeperUP();
                // this._addressTokenUSDL = await this._upManager.getTokenUSDL();
                // this._addressTokenLOAN = await this._upManager.getTokenLOAN();
                // this._addressTokenUP = await this._upManager.getTokenUP();
                // this._priceKeeperPLS = new PriceKeeperContract(this.addressPriceKeeperPLS, this._web3);
                // this._priceKeeperUP = new PriceKeeperContract(this.addressPriceKeeperUP, this._web3);
                // this._buyBurnPool = new BuyBurnPoolContract(await this._upManager.getBuyBurnPool(), this._web3);
                // this._stabilityPool = new StabilityPoolContract(await this._upManager.getStabilityPool(), this._web3);
                // this._internalExchangerBnB = new InternalExchangerBnBContract(await this._upManager.getInternalExchangerBnB(), this._web3);
                // this._internalExchangerSP = new InternalExchangerSPContract(await this._upManager.getInternalExchangerSP(), this._web3);
                // this._burnableUp = new BurnableContract(this._addressTokenUP, this._web3);
                // this._shareX = new ShareXContract(await this._upManager.getRewardPool(), this._web3);
                // if (await this._upManager.getStarted())
                // {
                //     const firstVault = await this._upManager.getLiquidController(0);
                //     if (firstVault.count!=0)
                //         this._liquidControllers.push(new LiquidControllerContract(firstVault.liquidController, this._web3, 0));
                //     let i = 1;
                //     while(i<firstVault.count){
                //         const data = await this._upManager.getLiquidController(i);
                //         this._liquidControllers.push(new LiquidControllerContract(data.liquidController, this._web3, i));
                //         i++;
                //     }
                // }
            }
            catch (e) {
                new modalCom.DialogOk(e).show();
            }
            yield this.app.awaitTime(2000);
        });
    }
}
exports.Web3Controller = Web3Controller;
//# sourceMappingURL=Web3Controller.js.map